import * as Api from '@ViewModels';
import type { AutomationStepNodeData } from '../types/stepNodes';
import { EmailStepRenderer } from './renderers/EmailStepRenderer';
import { TextingStepRenderer } from './renderers/TextingStepRenderer';
import { ActionItemStepRenderer } from './renderers/ActionItemStepRenderer';
import { SwitchStepRenderer } from './renderers/SwitchStepRenderer';
import { TagStepRenderer } from './renderers/TagStepRenderer';
import { OpportunityStepRenderer } from './renderers/OpportunityStepRenderer';
import { HtmlNewsletterStepRenderer } from './renderers/HtmlNewsletterStepRenderer';
import { HandwrittenCardStepRenderer } from './renderers/HandwrittenCardStepRenderer';
import { NoActionStepRenderer } from './renderers/NoActionStepRenderer';
import { TriggerAutomationStepRenderer } from './renderers/TriggerAutomationStepRenderer';

interface AutomationStepCardAdapterProps {
	nodeId: string;
	data: AutomationStepNodeData;
	mode: 'full' | 'compact';
	readOnly?: boolean;
}

export function AutomationStepCardAdapter({ nodeId, data, mode, readOnly = false }: AutomationStepCardAdapterProps) {
	if (mode === 'compact') {
		return null;
	}

	if ((data.stepType as string) === 'TriggerAutomation') {
		return <TriggerAutomationStepRenderer nodeId={nodeId} data={data} readOnly={readOnly} />;
	}

	switch (data.stepType) {
		case Api.AutomationStepType.Email:
			return <EmailStepRenderer nodeId={nodeId} data={data} readOnly={readOnly} />;

		case Api.AutomationStepType.Texting:
			return <TextingStepRenderer nodeId={nodeId} data={data} readOnly={readOnly} />;

		case Api.AutomationStepType.ActionItem:
			return <ActionItemStepRenderer nodeId={nodeId} data={data} readOnly={readOnly} />;

		case Api.AutomationStepType.AddTag:
		case Api.AutomationStepType.RemoveTag:
			return <TagStepRenderer nodeId={nodeId} data={data} readOnly={readOnly} />;

		case Api.AutomationStepType.Opportunity:
			return <OpportunityStepRenderer nodeId={nodeId} data={data} readOnly={readOnly} />;

		case Api.AutomationStepType.HtmlNewsletter:
			return <HtmlNewsletterStepRenderer nodeId={nodeId} data={data} readOnly={readOnly} />;

		case Api.AutomationStepType.HandwrittenCard:
			return <HandwrittenCardStepRenderer nodeId={nodeId} data={data} readOnly={readOnly} />;

		case Api.AutomationStepType.NoAction:
			return <NoActionStepRenderer nodeId={nodeId} data={data} readOnly={readOnly} />;

		case Api.AutomationStepType.Switch:
			return <SwitchStepRenderer nodeId={nodeId} data={data} readOnly={readOnly} />;

		default:
			return null;
	}
}
